package com.appsyde.shared.app.presentation.ticket

import com.appsyde.shared.modules.ticket.domain.model.Direction
import com.appsyde.shared.modules.ticket.domain.model.TicketRespondMessage
import com.appsyde.shared.modules.ticket.domain.model.TicketRespondState

/**
 * Builds the "active segment" (messages from pivot inbound to end) for the Respond UI.
 */
data class ActiveSegment(
    val pivotInbound: TicketRespondMessage?,
    val pivotInboundId: String?,
    val messages: List<TicketRespondMessage>
)

fun buildActiveSegment(respond: TicketRespondState): ActiveSegment {
    val sorted = respond.messages.sortedBy { it.sentAtMs }
    val pivotId = respond.lastInboundMessageId
        ?: respond.ticket.lastInboundMessageId
        ?: sorted.lastOrNull { it.direction == Direction.INBOUND }?.messageId
    val pivotIndex = pivotId?.let { id -> sorted.indexOfFirst { it.messageId == id } }?.takeIf { it >= 0 }
    val fallbackIndex = sorted.indexOfLast { it.direction == Direction.INBOUND }.takeIf { it >= 0 } ?: 0
    val startIndex = pivotIndex ?: fallbackIndex
    val segment = sorted.drop(startIndex)
    val pivotInbound = segment.firstOrNull { it.direction == Direction.INBOUND } ?: sorted.getOrNull(startIndex)
    return ActiveSegment(
        pivotInbound = pivotInbound,
        pivotInboundId = pivotInbound?.messageId ?: pivotId,
        messages = segment
    )
}
